import { ThemeProvider } from 'styled-components';
import { theme, GlobalStyles, useAccessibilityState, AccessibilityContext } from 'family-app-shared';
import AuthProvider from './components/Providers/AuthProvider';
// import AppRouterSimple from './components/Navigation/AppRouterSimple';
import AppRouter from './routes/AppRouter';
import LiffDebugInfo from './components/Debug/LiffDebugInfo';

function App() {
  const accessibilityState = useAccessibilityState();

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <AccessibilityContext.Provider value={accessibilityState}>
        {/* 新しいルーター (React Router + React Query) */}
        <AuthProvider>
          <AppRouter />
          {/* デバッグ情報（VITE_DEBUG_MODE=true の場合のみ表示） */}
          {import.meta.env.VITE_DEBUG_MODE === 'true' && <LiffDebugInfo />}
        </AuthProvider>
      </AccessibilityContext.Provider>
    </ThemeProvider>
  );
}

export default App;